import gql from 'graphql-tag';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const GET_DEAL_SHEET_CONFIGURATIONS = gql`
  query GetDealSheetConfigs {
    result: dealSheetConfigurations {
      success
      error
      list {
        ...DealSheetConfig
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
